import {Component, Input} from '@angular/core';
import {IChip} from '@lib-modules/chips/models/chip';

@Component({
  selector: 'lib-chip-list',
  template: '<lib-chip *ngFor="let chip of chips" [chip]="chip"></lib-chip>',
  styles: [
    ':host { display: block }'
  ]
})
export class ChipListComponent {

  @Input() public chips: IChip[];

}
